import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader } from "@nextui-org/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShield, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { refreshUserRole } from "../../utils/helper";
import { useParams } from "react-router-dom";

const NotAccess = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [debugInfo, setDebugInfo] = useState({});
  const { _orgId } = useParams();

  useEffect(() => {
    // Collect debug information
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    setDebugInfo({
      hasUserData: !!userData,
      userId: userData?.user?.id,
      userRole: userData?.user?.userRole,
      orgId: _orgId,
      currentPath: window.location.pathname,
      timestamp: new Date().toISOString()
    });
  }, [_orgId]);

  const handleRefreshPermissions = async () => {
    try {
      setIsRefreshing(true);
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      const userId = userData?.user?.id;
      
      if (userId && _orgId) {
        const newRole = await refreshUserRole(_orgId, userId);
        if (newRole) {
          // Reload the page to re-evaluate permissions
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("Error refreshing permissions:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <Card className="max-w-md w-full">
        <CardHeader className="flex flex-col items-center space-y-4 pb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <FontAwesomeIcon 
              icon={faShield} 
              className="text-red-600 text-2xl" 
            />
          </div>
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900">
              Access Denied
            </h1>
            <p className="text-gray-600 mt-2">
              You don't have permission to access this page.
            </p>
          </div>
        </CardHeader>
        
        <CardBody className="space-y-4">
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <span className="font-medium text-sm text-gray-700">Debug Information</span>
            </div>
            <div className="text-xs text-gray-600 space-y-1">
              <div>User ID: {debugInfo.userId || 'Not found'}</div>
              <div>User Role: {debugInfo.userRole || 'Not found'}</div>
              <div>Organization ID: {debugInfo.orgId || 'Not found'}</div>
              <div>Current Path: {debugInfo.currentPath}</div>
            </div>
          </div>

          <Button
            color="primary"
            variant="flat"
            startContent={<FontAwesomeIcon icon={faRefresh} />}
            onClick={handleRefreshPermissions}
            isLoading={isRefreshing}
            className="w-full"
          >
            Refresh Permissions
          </Button>

          <Button
            color="default"
            variant="bordered"
            onClick={() => window.history.back()}
            className="w-full"
          >
            Go Back
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default NotAccess;
